export default __webpack_public_path__ + "static/masterLogo-d74745c5f90d0db64877426757d42d59.png";